module.exports = __webpack_public_path__ + "static/media/ag.b8b82891.svg";